<template>
  <div class="tab-box">
    <ul class="nav nav-tabs">
      <li class="nav-item" v-for="tab in tabs" :key="tab">
        <button class="nav-link" :class="{'active': activeTab === tab}" :id="tab" type="button" :data-test="`btnBaseTab_${tab}`" @click="switchTab(tab)">
          <slot :name="tabHeadName(tab)">{{ tab }}</slot>
        </button>
      </li>

      <slot name="pagination"></slot>
    </ul>

    <div class="inside-box">
      <slot name="paginationMobile"></slot>

      <div class="tab-pane fade" :class="{'show active':  activeTab === tabSlotName}" :id="tabSlotName">
        <slot :name="tabSlotName"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .inside-box {
    position:                     relative;
  }

  .tab-pane {
    height:                       100%;
    display:                      flex !important; // override Bootstrap .tab-pane.active { display: block }
    flex-direction:               column;
    flex:                         1;
    min-height:                   0;
  }

  .nav-tabs {
    display:                      flex !important;
  }

</style>

<script>
export default {
  name: 'BaseTab',
  props: {
    initialtab: String,
    tabs: Array,
  },
  data() {
    return {
      activeTab: this.initialtab
    };
  },
  computed: {
    tabSlotName() {
      return `${this.activeTab}`;
    }
  },
  methods: {
    tabHeadName(tab) {
      return `tab-head-${tab}`;
    },

    switchTab(tab) {
      this.activeTab = tab;
      this.$emit('tab-activated', tab);
    }
  }
};
</script>
